const siteUrl = import.meta.env.VITE_SITE_URL || 'https://botan-buy.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/tenjin-ya#localbusiness`,
  name: '買取専門店 天神屋',
  alternateName: '天神屋 出張買取',
  description:
    '福岡市・福岡県全域への出張買取専門店。貴金属・宝石・ブランド品・カメラ・お酒・金券・骨董品・家電・楽器・電動工具・ゲーム・スマホ・タブレットを高価買取。出張費・査定費完全無料。',
  url: `${siteUrl}/tenjin-ya`,
  telephone: '+81-92-577-9739',
  email: 'info@botan-buy.com',
  image: 'https://public.readdy.ai/ai/img_res/3a89ad9b715a48f3f53c8a7bb7887ee9.jpg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '港1-2-18-1712',
    addressLocality: '福岡市中央区',
    addressRegion: '福岡県',
    postalCode: '810-0075',
    addressCountry: 'JP',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 33.5902,
    longitude: 130.3738,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '10:00',
      closes: '19:00',
    },
  ],
  areaServed: [
    { '@type': 'AdministrativeArea', name: '福岡県' },
    { '@type': 'AdministrativeArea', name: '福岡市' },
    { '@type': 'AdministrativeArea', name: '博多区' },
    { '@type': 'AdministrativeArea', name: '中央区' },
    { '@type': 'AdministrativeArea', name: '早良区' },
    { '@type': 'AdministrativeArea', name: '城南区' },
    { '@type': 'AdministrativeArea', name: '南区' },
    { '@type': 'AdministrativeArea', name: '東区' },
    { '@type': 'AdministrativeArea', name: '西区' },
    { '@type': 'AdministrativeArea', name: '春日市' },
    { '@type': 'AdministrativeArea', name: '大野城市' },
    { '@type': 'AdministrativeArea', name: '太宰府市' },
  ],
  priceRange: '¥',
  currenciesAccepted: 'JPY',
  paymentAccepted: '現金',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '買取品目',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '貴金属・宝石 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ブランド品 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'カメラ・レンズ 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'お酒・金券 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '骨董品・美術品 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '家電・楽器・電動工具 出張買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ゲーム・スマホ・タブレット 出張買取' } },
    ],
  },
  parentOrganization: {
    '@type': 'Organization',
    name: '株式会社BotaN',
    url: `${siteUrl}/`,
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '福岡市内への出張買取は費用がかかりますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '出張費・査定費は完全無料です。福岡市内はもちろん、福岡県全域への出張に対応しており、一切費用はかかりません。査定後に売却しないことも可能です。',
      },
    },
    {
      '@type': 'Question',
      name: '貴金属の買取はどのように査定しますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '金・プラチナ・シルバーなどの貴金属は、専用の計量器と純度測定器を使用して正確に査定します。市場の金相場に基づいた適正価格でご提示します。',
      },
    },
    {
      '@type': 'Question',
      name: '査定額に納得できなかった場合はどうなりますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '査定額にご納得いただけない場合は、売却しなくても構いません。キャンセル料・出張費は一切かかりませんのでご安心ください。',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
    { '@type': 'ListItem', position: 2, name: '買取専門店 天神屋', item: `${siteUrl}/tenjin-ya` },
  ],
};

const schemas = [localBusinessSchema, faqSchema, breadcrumbSchema];

export default function TenjinSeoJsonLd() {
  return (
    <>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
